import { Component, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as moment from "moment";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { AlertService } from "src/app/share/service/alert.service";
import { TranslateService } from "@ngx-translate/core";
import { MotorQuotationInterface } from "src/app/share/interface/motor-quotation.interface";
import SwiperCore, {
  Pagination,
  Autoplay,
  Navigation,
  SwiperOptions
} from "swiper";
import { SwiperComponent } from "swiper/angular";
SwiperCore.use([Pagination, Autoplay, Navigation]);

@Component({
	selector: "app-before-expired-dialog",
	templateUrl: "./before-expired-dialog.component.html",
	styleUrls: ["./before-expired-dialog.component.css"],
})
export class BeforeExpiredDialogComponent {
	@ViewChild("swiper", { static: true }) swiper: SwiperComponent;
	swiperOptions: SwiperOptions = {
		slidesPerView: 1,
		slidesPerGroup: 1,
		grabCursor: true,
		autoplay: {
			delay: 8000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
		pagination: {
			clickable: true
		}
	};
	
	day: number;
	campaignBannerUrl: string[];
	customerInput: Partial<MotorQuotationInterface>;

	constructor(
		private dialogRef: MatDialogRef<BeforeExpiredDialogComponent>,
		private motorDataDataService: MotorDataDataService,
		private alertService: AlertService,
		public translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.day = moment(data.expiryDate).diff(moment(), "day");
		this.campaignBannerUrl = data.campaignBannerUrl;
		this.customerInput = data.customerInput;
	}

	secureDiscountDeal()
	{
		if (this.campaignBannerUrl.length) {
			this.motorDataDataService.secureDiscountDeal(this.customerInput.vehicleNo, this.customerInput.identityNo).subscribe({
				next: (x) => {
					this.dialogRef.close(this.campaignBannerUrl.length);
				},
				error: (err) => {
					this.alertService.openSnackBar("Please contact policy street.");
				}
			});
		}
		else {
			this.dialogRef.close();
		}
	}
}
